<template>
	<page>
		<module title="收支记录详情">
			<c-detail >
				<c-detail-item label="收支记录号" >
					{{detailData.record_number}}
				</c-detail-item>
				<c-detail-item label="交易状态" >
					{{transStateName}}
				</c-detail-item>
				<c-detail-item label="交易金额" >
					{{detailData.money}}
				</c-detail-item>
				<c-detail-item label="交易商品数量" >
					{{detailData.count}}
				</c-detail-item>
				<c-detail-item label="会员余额" v-if="systemConfig.account_balance_enabled == 'ON'">
					{{detailData.surplus_money}}
				</c-detail-item>
				<c-detail-item label="收支类型" >
					{{incomeExpensesName}}
				</c-detail-item>
				<c-detail-item label="业务单号" >
					{{detailData.docket_number}}
				</c-detail-item>
				<c-detail-item label="第三方支付单号" >
					{{detailData.third_number}}
				</c-detail-item>
				<c-detail-item label="分类" >
					{{detailData.trans_classify}}
				</c-detail-item>
				<c-detail-item label="账单类型" >
					{{detailData.trans_type}}
				</c-detail-item>
				<c-detail-item label="收付渠道" >
					{{detailData.trans_channel}}
				</c-detail-item>
				<c-detail-item label="交易时间">
					{{detailData.create_date}}
				</c-detail-item>
				<c-detail-item label="会员手机号" >
					{{detailData.user_manage_mobilephone}}({{detailData.nick_name}})
				</c-detail-item>
				<c-detail-item label="会员账号" >
					{{detailData.login_name}}
				</c-detail-item>
				<c-detail-item label="交易摘要" full>
					{{detailData.remark}}
				</c-detail-item>
			</c-detail>
			
		</module>
		
	</page>
</template>

<script>
	import {mapState} from "vuex";

	export default {
		name: 'member_account_record_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {}
			}
		},
        watch: {
            id(){
                this.detail();
            }
        },
		mounted() {
			this.detail();
		},

		computed: {
			...mapState(['systemConfig']),

			transStateName() {
				return {
					1: '交易成功',
					2: '处理中',
					3: '提现失败'
				}[this.detailData.trans_state];
			},
			incomeExpensesName(){
				return {
					1: '收入',
					2: '支出'
				}[this.detailData.income_expenses];
			}
		},
		methods: {
			detail() {
				this.request({
					url: '/user/account/record/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data;
					}
				});
			}
		}
	}
</script>